var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseActionLessonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_12134)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_873_12134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4569 1.99747L3.63302 1.99747C3.03073 1.99747 2.54248 2.48572 2.54248 3.08801L2.54248 10.9119C2.54248 11.5142 3.03073 12.0024 3.63302 12.0024L11.4569 12.0024C12.0592 12.0024 12.5474 11.5142 12.5474 10.9119L12.5474 3.08801C12.5474 2.48572 12.0592 1.99747 11.4569 1.99747Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04346 1.99747L5.04346 12.0024",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0459 1.99747L10.0459 12.0024",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54248 6.99997L12.5474 6.99997",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54248 4.49875L5.04372 4.49875",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54248 9.50119L5.04372 9.50119",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0459 9.50119L12.5471 9.50119",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0459 4.49875L12.5471 4.49875",
    stroke: "#3A3A3A",
    strokeWidth: 1.20059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_12134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15.2727,
    fill: "white",
    transform: "translate(15.5454) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_873_12134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0059,
    height: 12.0059,
    fill: "white",
    transform: "translate(1.54199 0.99704)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseActionLessonIcon);
export default __webpack_public_path__ + "static/media/course_action_lesson_icon.cfdc71ee6a7e8c2157001762971bc881.svg";
export { ForwardRef as ReactComponent };